import { AxiosResponse } from "axios";
import get from "lodash-es/get";

import api from "app/api/requests/Users";
import getToken from "app/api/getToken";
import { IUserResponse } from "app/api/types";

export const GET_USER_PROFILES_REQUEST = "GET_USER_PROFILES_REQUEST";
export const GET_USER_PROFILES_SUCCESS = "GET_USER_PROFILES_SUCCESS";
export const GET_USER_PROFILES_FAIL = "GET_USER_PROFILES_FAIL";

export const getUserProfiles = () => (dispatch: any): any => {
  dispatch({ type: GET_USER_PROFILES_REQUEST });

  const token = getToken();

  return api
    .getUserProfiles(token)
    .then((response: AxiosResponse) => {
      const users: IUserResponse[] = get(response, "data", {});
      dispatch({ type: GET_USER_PROFILES_SUCCESS, payload: users });

      return users;
    })
    .catch(err => {
      dispatch({
        type: GET_USER_PROFILES_FAIL
      });
      throw get(err, "response.data.errors", {});
    });
};
